/**
 * Max returning time of all report graph
 */
export const MAX_RETURNING_TIME = 5;

export const GRAPH = {
	HEIGHT: 300,
};


// WEBPACK FOOTER //
// ./src/constants/limit.js